angular.module('bbl.common')
  .factory('TenyxRTC', ['Api', '$q', '$rootScope', _TenyxRTC]);

var TelnyxRTC = require('@telnyx/webrtc').TelnyxRTC;

var audio = document.createElement('audio');
$(audio).appendTo('body')
  .attr('id', 'tlnx-rtc-audio')
  .attr('autoplay', true);

var types = {
  READY: 'tlnxRTC.ready',
  LOGGED_IN: 'tlnxRTC.logged',
  TERMINATED: 'tlnxRTC.term',
  CALLING: 'tlnxRTC.calling',
  ANSWERED: 'tlnxRTC.answ',
  MEDIA_PERMISSION: 'tlnxRTC.perm'
};

function _TenyxRTC(Api, $q, $rootScope) {
  var client;

  var fetchCredentials = function() {
    return JSON.parse(sessionStorage.getItem('[bbl][tlnx][auth][tokens]')) || (
      Api.fetch('/call-control/auth/jwt').then(function(response) {
        sessionStorage.setItem('[bbl][tlnx][auth][tokens]', JSON.stringify(response.data));
        return response.data;
      })
    );
  };

  var initClient = function(loginToken) {
    return new Promise(function(resolve, reject) {
      // Initialize the client
      client = new TelnyxRTC({
        /* Use a JWT to authenticate (recommended) */
        login_token: loginToken,
      });

      client.remoteElement = audio;

      client.on('telnyx.ready', resolve)
            .on('telnyx.error', reject);

      // Connect and login
      client.connect();
    }).then(function() {
      client.off('telnyx.ready');
      client.off('telnyx.error');
    });
  };

  // var CONFIG = angular.copy(ENV.FREESWITCH);
  return {
    init: function() {
      return $q.when(fetchCredentials()).then(initClient, console.log);
    },

    makeCall: function(number) {
      var retryTimeout;
      var callInstance;
      var callPubsub = $rootScope.$new();

      // Create a variable to track the current call
      var activeCall;

      // Attach event listeners
      client
        // Events are fired on both session and call updates
        // ex: when the session has been established
        // ex: when there's an incoming call
        .on('telnyx.notification', function(notification) {
          if (notification.type !== 'callUpdate') {
            return;
          }
          activeCall = notification.call;
          switch(activeCall.state) {
            case 'new':
              callPubsub.$emit(types.CALLING, activeCall);
              break;
            case 'active':
              callPubsub.$emit(types.ANSWERED, activeCall);
              break;
            case 'hangup':
              if (activeCall.cause !== 'NORMAL_CLEARING') {
                retryTimeout = setTimeout(triggerCall, 250);
              } else {
                client.off('telnyx.notification');
                client.disconnect();
                callPubsub.$emit(types.TERMINATED, activeCall);
              }
              break;
            default: break;
          }
        });

      callPubsub.$on(types.ANSWERED, function() {
        // clear off all previous listeners
        client.off('telnyx.notification');

        // Attach event listeners
        client
          .on('telnyx.notification', function(notification) {
            if (notification.type !== 'callUpdate') {
              return;
            }
            activeCall = notification.call;
            switch(activeCall.state) {
              case 'hangup':
                callPubsub.$emit(types.TERMINATED, activeCall);
                break;
              case 'destroy':
                client.off('telnyx.notification');
                client.disconnect();
                break;
              default: break;
            }
          });
        });

      function triggerCall() {
        callInstance = client.newCall({
          // Destination is required and can be a phone number or SIP URI
          destinationNumber: number.replace(/^\+/, ''),
          callerNumber: number.replace(/^\+/, ''),
        });
      }

      function endCall() {
        clearInterval(retryTimeout);

        if (['hangup', 'destroy'].indexOf(activeCall.state) > -1) {
          return;
        }

        callInstance.hangup();
      }

      window.addEventListener('unload', endCall);

      triggerCall();

      return {
        types: types,
        on: callPubsub.$on.bind(callPubsub),
        end: endCall,

        dtmf: function(digit) {
          if(callInstance) callInstance.dtmf(digit);
        },

        mute: function() { if(callInstance) callInstance.muteAudio(); },
        unmute: function() { if(callInstance) callInstance.unmuteAudio(); },
      };
    },
  };
}




/*****************
 ** WEBPACK FOOTER
 ** ./app/common/call-providers/telnyx.js
 ** module id = 290
 ** module chunks = 0
 **/